
// In your component or separate file

// import { messaging } from "./fcmFirebase";

// export const generateFcmToken = async () => {
//   try {
//     console.log("Requesting notification permission...");
//     const permission = await Notification.requestPermission();

//     if (permission !== "granted") {
//       console.log("Notification permission denied");
//       return null;
//     }

//     console.log("Getting FCM token from separate project...");
//     const token = await messaging.getToken({
//       vapidKey: "BESiIy8N7Q_H8LnfYfdcOX6A-7y_8-TTVB6HPLfrCa4l9t6cW6haVitl0r7UQzurk-XO38NbjtI8OvpNj7LeR5E"
//     });

//     if (token) {
//       console.log("FCM Token generated successfully:", token);
//     } else {
//       console.log("No token received");
//     }

//     return token;

//   } catch (error) {
//     console.error("Error generating token:", error);
//     return null;
//   }
// };

import { messaging, isFCMAvailable } from "./fcmFirebase";

export const generateFcmToken = async () => {
  try {
    // First check if FCM is available at all
    if (!isFCMAvailable()) {
      console.log("FCM not supported on this device");
      return null;
    }

    if (!messaging) {
      console.log("FCM messaging not supported");
      return null;
    }

    if (!("Notification" in window)) {
      console.log("Notifications not supported");
      return null;
    }

    console.log("Requesting notification permission...");

    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Notification permission denied");
      return null;
    }

    const token = await messaging.getToken({
      vapidKey: "BESiIy8N7Q_H8LnfYfdcOX6A-7y_8-TTVB6HPLfrCa4l9t6cW6haVitl0r7UQzurk-XO38NbjtI8OvpNj7LeR5E"
    });

    console.log("FCM Token:", token);
    return token;

  } catch (error) {
    console.log("FCM ERROR", error);
    return null;
  }
};
